import { baseConfiguration } from 'utils/constants/customizer';

export const STY901 = {
  ...baseConfiguration,
};
